// @ts-nocheck
import { FIELD_TYPES } from 'pages/Forms/RegisterForm/CustomFormBuilder/config/constant';

const checkEmpty = (value) =>
  !value ||
  (Array.isArray(value) &&
    value.some((item) => !item || !item.file || item.file.trim() === '')) ||
  (typeof value === 'string' && !value.trim()) ||
  (Array.isArray(value) && value?.length === 0) ||
  (typeof value === 'object' && Object.keys(value)?.length === 0);

export const validateField = (
  name,
  value,
  isRequired,
  choices,
  selectedLinkListLabel,
) => {
  const isValueEmpty = checkEmpty(value);

  if (isRequired && isValueEmpty) {
    return 'This field is required';
  }
  switch (name) {
    case 'Full Name':
      if (value?.length > 32) {
        return 'Full Name cannot exceed 32 characters';
      }
      break;

    case 'Email':
      if (isRequired && isValueEmpty) {
        return 'This field is required';
      }

      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return 'Invalid email format';
      }
      break;
    case 'Short Text':
      if (value?.length > 100) {
        return 'Short text cannot exceed 100 characters';
      }
      break;

    case 'Yes/No/NA':
      if (isValueEmpty && isRequired) {
        return 'Please select Yes, No, or NA';
      }
      break;
    case 'Multi-Select Dropdown':
      if (isValueEmpty && isRequired) {
        return 'Please select at least one value';
      }
      break;

    case 'Single Select Dropdown':
      if (isValueEmpty && isRequired) {
        return 'Please select a value';
      }
      break;
    case 'Checkboxes':
    case 'Radio': {
      const selectedValues = value?.split(',') ?? [];

      const selectedOtherChoice = choices?.find(
        (item) => item.isOtherField && selectedValues.includes(item.id),
      );

      if (isValueEmpty && isRequired) {
        return 'Please select a value';
      }

      if (selectedOtherChoice && !selectedLinkListLabel?.trim()) {
        return 'Please enter a value for the "Other" option.';
      }

      break;
    }

    case 'Multiple Signature':
      if (
        (isValueEmpty && isRequired) ||
        value?.some(
          (item) =>
            !item ||
            !item.signatory_name ||
            item.signatory_name.trim() === '' ||
            !item.file ||
            item.file.trim() === '',
        )
      ) {
        return 'Please add both signature and signatory name .';
      }
      break;
    default:
      break;
  }

  return null;
};

export const validateForm = (formFields) => {
  const errors = {};

  formFields.forEach((field) => {
    const { id, answer, name, isRequired, choice, type } = field;

    if (type === FIELD_TYPES.TABLE || type === FIELD_TYPES.PREDEFINEDTABLE) {
      let isTableValid = !field.isRequired;
      field.contents.forEach((row) => {
        row.forEach((col) => {
          const fieldError = validateField(
            col.name,
            col.answer,
            col.isRequired,
            col.choice,
            col.selectedLinkListLabel,
          );

          if (field.isRequired && !checkEmpty(col.answer)) {
            isTableValid = true;
          }
          if (fieldError) {
            if (!errors[id]) errors[id] = {};
            errors[id][col.id] = fieldError;
          }
        });
      });

      if (!isTableValid) {
        if (!errors[id]) errors[id] = {};
        errors[id][id] = 'This field is required';
      }
    } else {
      const fieldError = validateField(
        name,
        answer,
        isRequired,
        choice,
        field.selectedLinkListLabel,
      );
      if (fieldError) errors[id] = fieldError;
    }
  });

  return errors;
};
